import { Divider } from 'antd';
import PropTypes from 'prop-types';

const GlobalDivider = ({ name, orientation = 'left' }) => {
  return (
    <Divider
      style={{
        marginTop: '2px',
        // marginBottom: '2px',
        fontWeight: '600',
        fontStyle: 'italic',
        color: 'green',
      }}
      orientation={orientation}
    >
      {name}
    </Divider>
  );
};

GlobalDivider.propTypes = {
  name: PropTypes.string.isRequired,
  orientation: PropTypes.oneOf(['left', 'right', 'center']),
};

export default GlobalDivider;
